// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetailCancelButton_container__1Itn1","text":"OfflineOrderDetailCancelButton_text__LtY4c","text-ltr":"OfflineOrderDetailCancelButton_text-ltr__vsNER"};